import React from "react";
import { FaEnvelope, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import "./book-page.m.css";

export default function ContactUs() {
  return (
    <section id="contact-section" styleName="contact-section">
      <div styleName="contact-container">
        <div styleName="contact-content">
          <div styleName="contact-title-wrapper">
            <div styleName="contact-title">Contact Us</div>
            <div styleName="contact-title-line" />
          </div>

          <a
            href="mailto:bookclub@newslaundry.com"
            styleName="contact-link"
          >
            <FaEnvelope />
            <span>bookclub@newslaundry.com</span>
          </a>

          <a
            href="https://www.instagram.com/nltnmbookclub/"
            target="_blank"
            rel="noopener noreferrer"
            styleName="contact-link"
          >
            <FaInstagram />
            <span>https://www.instagram.com/nltnmbookclub</span>
          </a>

          <a
            href="https://x.com/newslaundry"
            target="_blank"
            rel="noopener noreferrer"
            styleName="contact-link"
          >
            <FaXTwitter />
            <span>https://x.com/newslaundry</span>
          </a>
        </div>

        <div styleName="contact-image-wrapper">
          <img
            loading="lazy"
            src="https://images.assettype.com/newslaundry/2026-05-28/z6r6226b/contact.png"
            alt=""
            styleName="contact-image"
          />
        </div>
      </div>
    </section>
  );
}